import dayjs from "@/lib/helpers/dayjs";

// Sorts notes by session date in descending order (newest first). Creates a shallow copy to
// avoid mutating the original array. Falls back to 00:00 for missing session_from times.
// This mimics original moment behavior
export function sortNotesBySessionDate(notes) {
  return [...notes].sort((a, b) => {
    const sessionFromA = a.session_from || "00:00";
    const sessionFromB = b.session_from || "00:00";

    const dateA = dayjs(`${a.session_date} ${sessionFromA}`, "MM/DD/YYYY HH:mm");
    const dateB = dayjs(`${b.session_date} ${sessionFromB}`, "MM/DD/YYYY HH:mm");

    // Push notes with invalid/missing session_date to end of list to prevent NaN comparisons
    // from causing unstable sort order. Invalid dates likely indicate incomplete data entry
    // and are less important than recent valid notes in descending chronological order.
    if (!dateA.isValid()) return 1;
    if (!dateB.isValid()) return -1;

    return dateB.valueOf() - dateA.valueOf();
  });
}
